import { useAuth0 } from '@auth0/auth0-react';

/**
 * Custom hook that provides authentication state management
 * following Auth0's intended usage patterns
 */
export const useAuthState = () => {
    const { isAuthenticated, isLoading, user, loginWithRedirect, logout } = useAuth0();

    return {
        isAuthenticated,
        isLoading,
        user,
        loginWithRedirect,
        logout
    };
};
